<template>
  <span>
    <Select v-model="dataId" value-key="name" placeholder="请选择" filterable clearable :multiple="multiple">
      <Option v-for="role in roles" :key="role.name" :label="role.name" :value="role.name">
      </Option>
    </Select>
  </span>
</template>

<script>
import { AuthItemType } from '@/services/const'

import { AuthItemsService } from '@/services/resources'

export default {
  name: 'role-picker',
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataId: this.value,
      roles: []
    }
  },
  computed: {
  },
  beforeMount () {
    this.loadData()
  },
  methods: {
    loadData () {
      AuthItemsService.query({ 'per-page': 9999, 'page': 1, type: AuthItemType.Role }).then((res) => {
        this.roles = res.data
      })
    }
  },
  watch: {
    dataId (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    value (val) {
      this.dataId = val
    }
  }
}
</script>

<style lang="scss">
</style>
